import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const TK = "rx_access", RK = "rx_refresh";
export const clearTokens = () => { try { localStorage.removeItem(TK); localStorage.removeItem(RK); } catch (e) { /* storage unavailable */ } };
const getTok = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };

// Bearer fallback keeps sessions working where third-party cookies are blocked (e.g. embedded preview)
api.interceptors.request.use((cfg) => {
  const at = getTok(TK);
  if (at) cfg.headers.Authorization = `Bearer ${at}`;
  const rt = getTok(RK);
  if (rt && /\/auth\/(refresh|session)/.test(cfg.url || "")) cfg.headers["X-Refresh-Token"] = rt;
  return cfg;
});

const NO_RETRY = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];
let refreshing = null;

api.interceptors.response.use(
  (r) => {
    try {
      if (r.data?.access_token) localStorage.setItem(TK, r.data.access_token);
      if (r.data?.refresh_token) localStorage.setItem(RK, r.data.refresh_token);
    } catch (e) { /* storage unavailable */ }
    return r;
  },
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !NO_RETRY.some((p) => cfg.url?.includes(p))) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message && !e.response ? "Network error. Check your connection." : fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg?.replace(/^Value error, /, "") || "").filter(Boolean).join(" ");
  return d.msg || fallback;
}

export const ghs = (minor = 0) =>
  `GH₵ ${(minor / 100).toLocaleString("en-GH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);

export const fmtDate = (iso, withTime = false) =>
  iso
    ? new Date(iso).toLocaleString("en-GB", {
        day: "2-digit", month: "short", year: "numeric",
        ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
      })
    : "—";

export const PREDICTION_CATEGORIES = [
  { key: "football", title: "Football Predictions" },
  { key: "correct_score", title: "Correct Score" },
  { key: "package", title: "Prediction Packages" },
  { key: "daily", title: "Daily Predictions" },
  { key: "premium", title: "Premium Predictions" },
  { key: "other", title: "More Coming Soon" },
];
